import {Component, OnDestroy, OnInit} from '@angular/core';
import {TranslatePipe} from '@ngx-translate/core';
import {takeUntil} from 'rxjs/operators';
import {CoreConfigService} from '../../../../../@core/services/config.service';
import {forkJoin, Subject} from 'rxjs';
import {CustomField, FieldType} from '../../../../core/models/custom-field';
import {ActivatedRoute, Router} from '@angular/router';
import {CoreTranslationService} from '../../../../../@core/services/translation.service';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {HttpErrorResponse} from '@angular/common/http';
import {AuthenticationService} from '../../../../core/service';
import {CustomFieldService} from '../../../../core/service/custom-field.service';
import {GetCustomFieldsResponse} from '../../../../core/responses/GetCustomFieldsResponse';
import {AddUserCustomFieldRequest} from '../../../../core/requests/AddUserCustomFieldRequest';
import {selectValuesSeparator} from '../../../../core/helpers/constants';

@Component({
  selector: 'app-custom-register',
  templateUrl: './custom-register.component.html',
  styleUrls: ['./custom-register.component.scss'],
  providers: [ TranslatePipe ]
})
export class CustomRegisterComponent implements OnInit, OnDestroy {

  public coreConfig: any;
  public companyId = 0;
  public submitted = false;
  public customFields: Array<CustomField | any> = [];
  public customFieldsForm: FormGroup;
  private _unsubscribeAll: Subject<void>;


  constructor(
    private _coreConfigService: CoreConfigService,
    private _route: ActivatedRoute,
    private _router: Router,
    private _coreTranslationService: CoreTranslationService,
    private authenticationService: AuthenticationService,
    private customFieldsService: CustomFieldService
  ) {
    this.companyId = parseInt(this._route.snapshot.params.companyId || '', 10);
    this._unsubscribeAll = new Subject();

    // Configure the layout
    this._coreConfigService.config = {
      layout: {
        navbar: {
          hidden: true
        },
        menu: {
          hidden: true
        },
        footer: {
          hidden: true
        },
        customizer: false,
        enableLocalStorage: false
      }
    };
    // this._coreTranslationService.translate(english, romanian);
  }

  // convenience getter for easy access to form fields
  get f() {
    return this.customFieldsForm.controls;
  }

  ngOnInit() {
    // Subscribe to config changes
    this._coreConfigService.config.pipe(takeUntil(this._unsubscribeAll)).subscribe(config => {
      this.coreConfig = config;
    });
    this.getCustomFields();
  }

  /**
   * On destroy
   */
  ngOnDestroy() {
    // Unsubscribe from all subscriptions
    this._unsubscribeAll.next();
    this._unsubscribeAll.complete();
  }

  getCustomFields() {
    const params = {
      paginationCriteria: {
        start: 0,
        limit: 500
      },
      companyId: this.companyId
    };

    this.customFieldsService.getCustomFields(params)
      .subscribe(
        data => {
          this.getCustomFieldsSuccess(data);
        },
        error => {
          this.getCustomFieldsFail(error);
        });
  }

  getCustomFieldsSuccess(data: GetCustomFieldsResponse) {
    this.customFields = data.responseObject.data
      .map(customField => ({
        ...customField,
        parsedSelectedValues: customField.selectValues ? customField.selectValues.split(selectValuesSeparator) : null
      }));
    if (this.customFields.length === 0) {
      setTimeout(() => {
        var subdomain = this._route.snapshot.params['subdomain'];
        const returnUrl = localStorage.getItem('returnUrl') || `/${subdomain}/home`;
        localStorage.removeItem('returnUrl');
        this._router.navigate([returnUrl]);
      }, 100);
      return;
    }
    const fields = {};
    this.customFields.forEach(customField => {
      const formState = customField.fieldType === FieldType.Checkbox
        ? customField.defaultValue === 'true'
        : customField.defaultValue || '';
      fields[customField.id] = new FormControl(formState, customField.requiredFlag ? [Validators.required] : []);
    });
    this.customFieldsForm = new FormGroup(fields);
  }

  public getCustomFieldsFail(error: HttpErrorResponse) {
    console.warn('Loading custom fields failed: ', error);
  }

  onSubmit() {
    const joined = forkJoin(
      Object.keys(this.f)
        .map(customFieldId => this.saveUserCustomFields(parseInt(customFieldId, 10)))
    );
    joined
      .subscribe(
        _ => {
          this.addUserCustomFieldsSuccess();
        },
        error => {
          this.addUserCustomFieldsFail(error);
        });
  }

  saveUserCustomFields(customFieldId: number) {
    const params: AddUserCustomFieldRequest = {
      userId: this.authenticationService.currentUserValue.userId,
      customFieldId: customFieldId,
      value: this.f[customFieldId].value,
    };
    return this.customFieldsService.addUserCustomField(params);
  }

  public addUserCustomFieldsSuccess() {
    // redirect to login
    this._router.navigate(['/']);
  }

  public addUserCustomFieldsFail(error: HttpErrorResponse) { }

}
